var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React, { useState } from 'react';
import PlacesAutocomplete, { geocodeByPlaceId } from 'react-places-autocomplete';
import { Input } from 'ui/styled';
import { Dropdown, Suggestion } from './styled';
export function mapGeocodedAddress(source) {
    var result = {
        address_1: '',
        address_2: '',
        city: '',
        state: '',
        zip: ''
    };
    source.address_components.forEach(function (component) {
        component.types.forEach(function (type) {
            switch (type) {
                case 'postal_code':
                    result.zip = component.long_name;
                    break;
                case 'street_number':
                    result.address_1 = result.address_1
                        ? "".concat(component.long_name, " ").concat(result.address_1)
                        : component.long_name;
                    break;
                case 'route':
                    result.address_1 = result.address_1
                        ? "".concat(result.address_1, " ").concat(component.long_name)
                        : component.long_name;
                    break;
                case 'administrative_area_level_1':
                    result.state = component.short_name;
                    break;
                case 'neighborhood':
                case 'administrative_area_level_3':
                case 'administrative_area_level_2':
                    result.city = result.city || component.long_name;
                    break;
                case 'locality':
                    result.city = component.long_name;
                    break;
                case 'premise':
                case 'subpremise':
                    result.address_2 = component.long_name;
                    break;
                default:
                    break;
            }
        });
    });
    return result;
}
var AddressAutocomplete = function (_a) {
    var onChange = _a.onChange, _b = _a.value, value = _b === void 0 ? '' : _b, _c = _a.dataTestProp, dataTestProp = _c === void 0 ? 'addressAutocomplete' : _c;
    var _d = useState(value), searchValue = _d[0], setSearchValue = _d[1];
    var handleChange = function (v) {
        setSearchValue(v);
        onChange === null || onChange === void 0 ? void 0 : onChange(v);
    };
    var handleSelect = function (_place, placeId) { return __awaiter(void 0, void 0, Promise, function () {
        var results, result, parsedResult, mainAddress, formattedAddress, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, geocodeByPlaceId(placeId)];
                case 1:
                    results = _a.sent();
                    result = results === null || results === void 0 ? void 0 : results[0];
                    if (result) {
                        parsedResult = mapGeocodedAddress(result);
                        mainAddress = "".concat(parsedResult === null || parsedResult === void 0 ? void 0 : parsedResult.address_1).concat((parsedResult === null || parsedResult === void 0 ? void 0 : parsedResult.address_2) ? ", ".concat(parsedResult.address_2) : '');
                        formattedAddress = "".concat(mainAddress ? "".concat(mainAddress, ", ") : '').concat(parsedResult === null || parsedResult === void 0 ? void 0 : parsedResult.city, ", ").concat(parsedResult === null || parsedResult === void 0 ? void 0 : parsedResult.state, ", ").concat(parsedResult === null || parsedResult === void 0 ? void 0 : parsedResult.zip);
                        // Later to be parsed again in composeVariables method
                        handleChange(formattedAddress);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    // eslint-disable-next-line no-console
                    console.error('Error:', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var searchOptions = {
        componentRestrictions: { country: 'us' },
        types: ['premise', 'subpremise', 'street_address', 'postal_code']
    };
    return (_jsx(PlacesAutocomplete, { value: searchValue, onChange: handleChange, onSelect: handleSelect, searchOptions: searchOptions, debounce: 500, children: function (_a) {
            var getInputProps = _a.getInputProps, suggestions = _a.suggestions, getSuggestionItemProps = _a.getSuggestionItemProps, loading = _a.loading;
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            var _b = getInputProps({
                placeholder: 'Address'
            }), size = _b.size, inputProps = __rest(_b, ["size"]);
            return (_jsxs(_Fragment, { children: [_createElement(Input, __assign({}, inputProps, { key: "placeholder", "data-test": "".concat(dataTestProp, ".input") })), !loading && suggestions.length > 0 && (_jsx(Dropdown, { children: suggestions.map(function (suggestion) { return (_createElement(Suggestion, __assign({}, getSuggestionItemProps(suggestion), { key: suggestion.placeId, "data-test": "".concat(dataTestProp, ".option") }), suggestion.description)); }) }))] }));
        } }));
};
export default AddressAutocomplete;
